import React, { useEffect, useState } from "react";
import "./../../styles/Sidebar.css";
import StoreSelector from "./StoreSelector.js";
import Menu from "./Menu.js";
import TroubleshootNotice from "./TroubleshootNotice.js";
import config from "../../constants/config.js";

function Sidebar() {
    const [ loadingMenus , setLoadingMenus ] = useState( true );
    const [ menus , setMenus ] = useState( [] );

    useEffect( () => {
        async function loadData() {
            setLoadingMenus( true );

            try {
                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/menus`;
                const requestSettings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                const response = await fetch( url , requestSettings );
                const data = await response.json();

                if ( data?.menus?.length > 0 ) {
                    setMenus( data.menus )
                }
            } catch ( error ) {
                console.log( error );
            } finally {
                setLoadingMenus( false );
            }
        }

        loadData();
        } , [] )

    return (
        <aside className="sidebar">
            <div className="primary-content">
                <StoreSelector />
                { menus.length > 0 && !loadingMenus && menus.map( ( menu ) => {
                    return(
                        <Menu key={ menu.id } title={ menu?.title } links={ menu?.links } />
                    )
                })}

                { loadingMenus && 
                    <>
                        <div className="menu-section-skeleton"></div>
                        <div className="menu-section-skeleton"></div>
                        <div className="menu-section-skeleton"></div>
                    </>
                }
            </div>
            
            <div className="troubleshooting-notice-wrapper">
                <TroubleshootNotice />
            </div>
        </aside>
    );
}

export default Sidebar;